/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserReportRead } from './UserReportRead';
import {
    UserReportReadFromJSON,
    UserReportReadFromJSONTyped,
    UserReportReadToJSON,
    UserReportReadToJSONTyped,
} from './UserReportRead';

/**
 * Paginated response for the superadmin report list.
 * @export
 * @interface PaginatedUserReportsResponse
 */
export interface PaginatedUserReportsResponse {
    /**
     * Reports on this page
     * @type {Array<UserReportRead>}
     * @memberof PaginatedUserReportsResponse
     */
    items: Array<UserReportRead>;
    /**
     * Total number of matching reports
     * @type {number}
     * @memberof PaginatedUserReportsResponse
     */
    total: number;
    /**
     * Number of records skipped
     * @type {number}
     * @memberof PaginatedUserReportsResponse
     */
    skip: number;
    /**
     * Maximum number of records returned
     * @type {number}
     * @memberof PaginatedUserReportsResponse
     */
    limit: number;
}

/**
 * Check if a given object implements the PaginatedUserReportsResponse interface.
 */
export function instanceOfPaginatedUserReportsResponse(value: object): value is PaginatedUserReportsResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('skip' in value) || value['skip'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function PaginatedUserReportsResponseFromJSON(json: any): PaginatedUserReportsResponse {
    return PaginatedUserReportsResponseFromJSONTyped(json, false);
}

export function PaginatedUserReportsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedUserReportsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(UserReportReadFromJSON)),
        'total': json['total'],
        'skip': json['skip'],
        'limit': json['limit'],
    };
}

export function PaginatedUserReportsResponseToJSON(json: any): PaginatedUserReportsResponse {
    return PaginatedUserReportsResponseToJSONTyped(json, false);
}

export function PaginatedUserReportsResponseToJSONTyped(value?: PaginatedUserReportsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(UserReportReadToJSON)),
        'total': value['total'],
        'skip': value['skip'],
        'limit': value['limit'],
    };
}

